export default __webpack_public_path__ + "static/media/tempIcon.441dbfcb.svg";